import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, AbstractControl, FormControl } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { EmailService } from 'src/app/modules/shared/services/email/email.service';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';
import { ComponentReloadService } from 'src/app/modules/shared/services/reload/component-reload.service';
import { ModalsService } from 'src/app/modules/shared/services/modals/modals.service';
import { jwtDecode } from 'jwt-decode';
import { ClientAdminService } from 'src/app/business-service/client-admin/client-admin.service';

@Component({
  selector: 'app-emailpopup',
  templateUrl: './emailpopup.component.html',
  styleUrls: ['./emailpopup.component.scss'],
})
export class EmailpopupComponent implements OnInit {


  quotationForm!: FormGroup;
  selectedFileName: string = ''; // Stores uploaded file name
  response: any;
  @Input() emails: any;
  allFromEmails: any;
  @Input() itineraryDetails: any;
  @Input() totalNoOfNights: any;
  @Input() leadId: any;
  @Input() selectedDmcIds: any;
  @Input() selectedVendorIds: any;
  @Input() loadData: boolean = false;
  @Input() emaildata: any;
  fileErrorMessage: string = '';

  @Input() viewOnly: boolean = false;

  userDetails: any;

  constructor(private fb: FormBuilder, private modalController: ModalController,
    private _globalService: GlobalService,
    private _emailService: EmailService,
    private _responseNotificationService: ResponseNotificationService,
    private _reloadService: ComponentReloadService,
    private _modalPopupService: ModalsService,
    private _clientAdminService: ClientAdminService
  ) {

  }

  async ngOnInit() {
    // this.allFromEmails = this._globalService.retrieveEmailsFromToken(true);
    this.allFromEmails = this._globalService.retrieveOrganizationVerifiedEmails();
    let currentUser = localStorage.getItem('sub') || '';
    this.userDetails = await this.getUserDetails(localStorage.getItem("userId"));
    this.userDetails = this.userDetails.userDetail;
    if (this._globalService.getUserSenderAccess() && this._globalService.getUserSenderAccess() === "SUCCESS") {
      this.allFromEmails.push(currentUser);
    }

    this.quotationForm = this.fb.group({
      fromEmail: [this.allFromEmails.at(-1) || '', [Validators.required, Validators.email]],
      toEmails: this.fb.array([], [this.minEmailsValidator(1)]),
      newEmail: [''], // Temporary field for adding new email
      subject: ['', Validators.required],
      clientInfo: this.fb.group({
        destination: ['', Validators.required],
        tripStartDate: ['', Validators.required],
        tripEndDate: ['', Validators.required],
        nightsDays: ['', Validators.required],
        passengers: ['', Validators.required],
        flexibleDays: [false],
        hotelType: [''],
        noOfRooms: [0],
        budget: [''],
      }),
      notes: ['', Validators.required],
      isConfirmed: [false, Validators.requiredTrue],
      attachment: [null]
    });

    if (this.viewOnly) {
      this.quotationForm.get("subject")?.disable();
      this.quotationForm.get("notes")?.disable();
    }


    if (this.itineraryDetails) {
      const destination = this.itineraryDetails.destinationDaysArray
        ?.map((dest: any) => (dest.location).split(',')[0]).join(',');
      const formattedStartDate = this._globalService.formatDate(this.itineraryDetails.startDate, 'DD/MM/YYYY');
      const formattedEndDate = this._globalService.formatDate(this.itineraryDetails.endDate, 'DD/MM/YYYY');
      // Create real Date objects for Client Info binding (Updated her as per the Version9 requirement)
      const startDateObj = new Date(this.itineraryDetails.startDate);
      const endDateObj = new Date(this.itineraryDetails.endDate);
      const nightsDays = `${this.totalNoOfNights}N/${this.totalNoOfNights + 1}D`;
      const passengers = this.itineraryDetails.noOfGuests.noOfAdults + " Adults " + this.itineraryDetails.noOfGuests.noOfChildren + " Children " + this.itineraryDetails.noOfGuests.noOfInfants + " Infants";

      this.quotationForm.patchValue({
        clientInfo: {
          destination: destination,
          tripStartDate: startDateObj,
          tripEndDate: endDateObj,
          nightsDays: nightsDays,
          passengers: passengers,
          flexibleDays: this.itineraryDetails.flexibleDays,
          hotelType: this.itineraryDetails.hotelType,
          noOfRooms: this.itineraryDetails.noOfRooms,
          budget: this.itineraryDetails.budget
        },
        subject: `Quotation request for ${destination}`,
        notes: this.generateNotes(destination, formattedStartDate, formattedEndDate, nightsDays, passengers, this.itineraryDetails)
      });
    }
    else if (this.loadData && this.emaildata) {
      this.quotationForm.patchValue({
        subject: this.emaildata.subject || '',
        clientInfo: {
          destination: this.emaildata.destination || '',
          tripStartDate: this.emaildata.tripStartDate || '',
          tripEndDate: this.emaildata.tripEndDate || '',
          nightsDays: this.emaildata.nightsDays || '',
          passengers: this.emaildata.passengers || '',
        },
        notes: this.emaildata.notes || '',
        isConfirmed: this.emaildata.isConfirmed || false,
        attachment: this.emaildata.attachment || null
      });
      this.selectedFileName = this.emaildata?.attachment?.fileName;
      this.leadId = this.emaildata.leadId;
      this.selectedDmcIds = this.emaildata.dmcIds;
      this.selectedVendorIds = this.emaildata.vendorIds;
      const toEmailsArray = this.quotationForm.get('toEmails') as FormArray;
      toEmailsArray.clear(); // Remove existing entries

      if (this.emaildata.toEmails && Array.isArray(this.emaildata.toEmails)) {
        this.emaildata.toEmails.forEach((email: any) => {
          toEmailsArray.push(new FormControl(email, [Validators.required, Validators.email]));
        });
      }
    }




    if (this.emails && this.emails.length) {
      const toEmailsArray = this.quotationForm.get('toEmails') as FormArray;
      this.emails.forEach((email: string) => {
        toEmailsArray.push(this.fb.control(email, [Validators.required, Validators.email]));
      });
    }

  }


  generateNotes(destination: string, formattedStartDate: string, formattedEndDate: string, nightsDays: string, passengers: string, itineraryDetails: any): string {
    return `<p><strong>Dear User,</strong></p>
            <p></p>
            <p><strong>Greetings!!!</strong></p>
            <p></p>
            <p>Destination: ${destination}<br>Travel start date: ${formattedStartDate}<br>Travel end date: ${formattedEndDate}<br>Are Dates Flexible: ${itineraryDetails.flexibleDays ? "Yes" : "No"}<br>No. Of Passengers: ${passengers}<br>No. Of Nights: ${this.totalNoOfNights}<br> Prefered hotel category and rooms: ${itineraryDetails.hotelType || "--"} / ${itineraryDetails.noOfRooms || "--"} Room<br>Budget: ${itineraryDetails.budget} Rs</p>
            <p></p>
            <p>Kindly quote land costing for the above-mentioned details.<br>I am reaching out to request a detailed ${destination} itinerary and quotation for my client who is planning a trip. Please provide a comprehensive proposal including :</p>
            <p></p>
            <p><strong>Suggested itinerary for ${nightsDays}</strong></p>
            <p>Accommodation options (Hotel category &amp; meal plan)<br>Inclusions (Transfers, sightseeing, activities, guide services, etc.)<br>Pricing breakdown (per person/group)<br>Any optional add–ons or customizations<br>Booking terms, cancellation policy, and payment details</p>
            <p>The tentative travel dates are ${formattedStartDate} to ${formattedEndDate}, and the group consists of ${passengers}. Kindly share the best available rates and any special offers, if applicable.</p>
            <p></p>
            <p>Regards,</p>
            <p>${localStorage.getItem("userName")},</p>
            <p>${localStorage.getItem("CName")},</p>
            <p>${this.userDetails.officePhoneNumber?.countryCode} ${this.userDetails?.officePhoneNumber?.phone},</p>
            <p>${localStorage.getItem("sub")}</p>`;
  }

  async getUserDetails(userId: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this._clientAdminService.getUser(userId).subscribe({
        next: (data) => {
          resolve(data);
        },
        error: (err) => {
          reject(err);
        }
      })
    })

  }

  // Getter for FormArray
  get toEmails(): FormArray {
    return this.quotationForm.get('toEmails') as FormArray;
  }

  // Custom Validator for minimum required emails
  minEmailsValidator(min: number) {
    return (formArray: AbstractControl) => {
      return (formArray as FormArray).length >= min ? null : { minEmails: true };
    };
  }

  // Add new email dynamically
  addEmail() {
    const newEmailValue = this.quotationForm.get('newEmail')?.value;
    if (newEmailValue && !this.toEmails.value.includes(newEmailValue)) {
      this.toEmails.push(this.fb.control(newEmailValue, [Validators.required, Validators.email]));
      this.quotationForm.get('newEmail')?.reset();
    }
  }

  // Remove an email, ensuring at least one remains
  removeEmail(index: number) {
    if (this.toEmails.length > 0) {
      this.toEmails.removeAt(index);
    }
  }

  onFileSelected(event: any) {
    this.selectedFileName = "";
    this.quotationForm.patchValue({
      attachment: null // Clear the attachment data
    });
    const file = event.target.files[0];

    if (file) {
      const maxSizeInMB = 2;
      const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

      if (file.size > maxSizeInBytes) {
        this.fileErrorMessage = `File size exceeds ${maxSizeInMB}MB. Please upload a smaller file.`;
        return;
      } else
        this.fileErrorMessage = ''
    }
    this.selectedFileName = file.name;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64File = reader.result?.toString().split(',')[1]; // Extract Base64
      this.quotationForm.patchValue({
        attachment: {
          fileName: file.name,
          fileType: file.type,
          fileData: base64File
        }
      });
    };
  }
  openAttachedFile() {
    const attachment = this.quotationForm.value.attachment;

    if (attachment && attachment.fileData) {
      const byteCharacters = atob(attachment.fileData);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: attachment.fileType });
      const fileURL = URL.createObjectURL(blob);
      // this.modalController.dismiss();
      this._modalPopupService.openImageModal(fileURL);
    }
  }

  clearFile() {
    this.selectedFileName = "";
    this.quotationForm.patchValue({
      attachment: null // Clear the attachment data
    });

    const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = ''; // Reset file input
    }
  }


  async sendQuotation() {

    var emaildata = {
      leadId: this.leadId,
      vendorIds: this.selectedVendorIds,
      dmcIds: this.selectedDmcIds,
      fromEmail: this.quotationForm.value.fromEmail,
      toEmails: this.quotationForm.value.toEmails,
      destination: this.quotationForm.value.clientInfo.destination,
      tripStartDate: this.quotationForm.value.clientInfo.tripStartDate,
      tripEndDate: this.quotationForm.value.clientInfo.tripEndDate,
      nightsDays: this.quotationForm.value.clientInfo.nightsDays,
      passengers: this.quotationForm.value.clientInfo.passengers,
      notes: this.quotationForm.value.notes,
      attachment: this.quotationForm.value.attachment,
      subject: this.quotationForm.value.subject
    };
    //   const modal = this.modalController.create({
    //     component: SuccesspopupComponent,
    //     componentProps: {
    //       location: this.quotationForm.value.clientInfo.destination,
    //       emailList: this.quotationForm.value.toEmails, 
    //     },
    //     backdropDismiss: false, // Prevents closing on clicking outside
    //     cssClass: 'email-modal-popup-css' // Optional: Add custom styling
    // });
    //  await modal.present();
    if (this.quotationForm.valid) {
      this._emailService.sendVendorDmc(emaildata).subscribe({
        next: async (data: any) => {
          this._responseNotificationService.showMessage("Email sent successful!");
          this.response = data;
          // this._reloadService.triggerreloadVendorDmcsInLeadDetails();
          await this._reloadService.triggerTravelPrefReload();
          await this._reloadService.triggerreloadVendorDmcsInPopup();
          this.modalController.dismiss({
            submitted: true
          });


        },
        error: (err: any) => {
          this._responseNotificationService.showMessage("Failed to send email.", true);
          console.error("Error sending email:", err);
        }
      });


    }
  }

  isFieldInvalid(field: string): boolean {
    const control = this.quotationForm.get(field);
    return control ? control.invalid && (control.touched || control.dirty) : false;
  }


  closeModal() {
    this.modalController.dismiss();
  }
}
